import React, { ReactNode } from 'react'

import './DrawerDetail.css'
import { DrawerDetailProvider } from './DrawerDetailContext'

const DrawerDetail = ({ children, color = "white" }: { children: ReactNode, color?: string }) => {
    return (
        <DrawerDetailProvider theme={{ color }}>
            <div className='drawer-detail'>
                {children}
            </div>
        </DrawerDetailProvider>
    )
}

export default DrawerDetail